import React from 'react';
import { BookmarkContainer } from './bookmarkStyles';
import { BookmarkIcon } from '../Icons/Icons';
import { useAppDispatch, useAppSelector } from '../../../state/hooks';
import { RootState } from '../../../state/store';
import { isEqual } from 'lodash';
import {
	BOOKMARK_ADD_PLACE,
	BOOKMARK_DEL_PLACE,
	BookmarkReducerAction,
} from '../../../state/bookmarksSlice';

type BookmarkButtonProps = {
	placeId: number;
};

const BookmarkPlaceButton: React.FC<BookmarkButtonProps> = ({ placeId }) => {
	const dispatch = useAppDispatch();
	const bookmarkedPlaces = useAppSelector(
		(state: RootState) => state.bookmarks.places,
		isEqual,
	);
	const isBookmarked = bookmarkedPlaces.includes(placeId);

	const handleToggleBookmark = () => {
		switch (isBookmarked) {
			case true:
				dispatch({
					type: BOOKMARK_DEL_PLACE,
					payload: {
						action_id: placeId,
					},
				} as BookmarkReducerAction);
				break;

			default:
				dispatch({
					type: BOOKMARK_ADD_PLACE,
					payload: {
						action_id: placeId,
					},
				} as BookmarkReducerAction);
		}
	};
	// const handleClick = () => {
	// 	onClick();
	// 	console.log(
	// 		'bookmark toggle requested, current state : ',
	// 		isBookmarked,
	// 	);
	// 	// TODO: Dispatch Bookmark Reducer Action
	// };
	return (
		<BookmarkContainer
			onClick={() => handleToggleBookmark()}
			className={isBookmarked ? 'bookmarked' : ''}>
			<BookmarkIcon />
		</BookmarkContainer>
	);
};

export default BookmarkPlaceButton;
